'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = scrollPositionDecorator;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scrollPositionDecorator(Wrapped) {
  return function (_React$Component) {
    (0, _inherits3.default)(ScrollPosition, _React$Component);

    function ScrollPosition() {
      (0, _classCallCheck3.default)(this, ScrollPosition);

      var _this = (0, _possibleConstructorReturn3.default)(this, (ScrollPosition.__proto__ || (0, _getPrototypeOf2.default)(ScrollPosition)).apply(this, arguments));

      _this.state = {
        windowScrollX: 0,
        windowScrollY: 0
      };

      _this.updateScrollState = _this.updateScrollState.bind(_this);
      return _this;
    }

    (0, _createClass3.default)(ScrollPosition, [{
      key: 'updateScrollState',
      value: function updateScrollState() {
        this.setState({
          windowScrollX: window.scrollX,
          windowScrollY: window.scrollY
        });
      }
    }, {
      key: 'componentWillMount',
      value: function componentWillMount() {
        this.updateScrollState();
        window.addEventListener('scroll', this.updateScrollState);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeEventListener('scroll', this.updateScrollState);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Wrapped, (0, _extends3.default)({}, this.props, { windowScrollX: this.state.windowScrollX, windowScrollY: this.state.windowScrollY }));
      }
    }]);
    return ScrollPosition;
  }(_react2.default.Component);
}
//# sourceMappingURL=scrollPosition.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/decorators/scrollPosition.js
// module id = 630
// module chunks = 0